























import {Vue, Component, Watch, Prop} from 'vue-property-decorator'

@Component({})
export default class TakenImages extends Vue {
  @Prop() params!: { userId: null, date: null };

  images = [];

  @Watch('params', {deep: true})
  async onParamsChange(params) {
    if (params.userId && params.date) {
      await this.axios.get('api/GetImagesFromDailyVisits', {
        params: {
          userId: params.userId,
          date: params.date
        }
      }).then(result => {
        this.images = result.data;
      });
      $(".photoStackTakenImages").Photostack({
        animation: 'elastic'
      });
      $(".fancybox").fancybox({
        animationEffect: 'zoom',
        transitionEffect: 'slide',
        caption: function () {
          return $(this).attr('rel');
        },
        thumbs: {
          autoStart: true,
        },
      });
    }
  }

  startSlideShow() {
    let opts = {
      animationEffect: 'zoom',
      transitionEffect: 'slide',
      slideShow : {
        autoStart : true
      },
      caption: function () {
        return $(this).attr('rel');
      },
      thumbs: {
        autoStart: true,
      },
    };
    $.fancybox.open($("#takenImages a[href]"), opts );

  }
}
